module.exports = __webpack_public_path__ + "media/rendering/renderingFullService-1c651f8d.png";